module.exports = __webpack_public_path__ + "static/media/A1-13-Zyntaris-cod95.2de8040f.png";